// @flow

import ApiObject from '../ApiObject';


export default class DeliveryTimeSettings extends ApiObject {

  amountFromAccount: number;

  grantAmount: number;

  grantLabel: number;

  postJsonAsssignation(data: Object) {
  }
  
  toJSON() {
    // custom serialization,
    // handle new format of the data (subsidies)
    // since the order preview returns a subsidies to us, we have it on our data
    // we our v1 fronts only use the old data (defined on this object)
    // so the api receive correct old data but new data from the order preview that is incorrect
    // The Api will recalculate the subsidies information, so no need to add additionnal data. We 
    // just need to have only the old data, only the new data, are both data the same
    return {
      ...this,
      // soluce 1: better since it represent the old data model, not a trick to have both models
      subsidies: undefined,
      // soluce 2
      // subsidies: {
      //   grantAmount: this.grantAmount,
      //   label: this.grantLabel,
      //   tax: this.grantTax,
      // }
    }
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/order/UserAccountPayment.js